import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkAsButton } from '@printdeal/ui-library';
import { addDataLayerEntry, addEventEntry } from '@printdeal/data-layer-manager';
import { saveAs } from 'file-saver';
import { Buffer } from 'buffer';
import { ErrorManagement } from '@printdeal/error-management/react';
import ApiContext from '../../../contexts/ApiContext';

interface Props {
  invoiceNumber: string;
}

const InvoiceDownloadButton = ({ invoiceNumber }: Props) => {
  const { invoiceApi } = useContext(ApiContext);
  const [isDownloading, setIsDownloading] = React.useState<boolean>(false);

  const downloadInvoice = async () => {
    if (!invoiceApi) {
      throw new Error('Invoice API not available');
    }

    await invoiceApi.downloadInvoice(invoiceNumber).then((invoice) => {
      const blob = new Blob([Buffer.from(invoice, 'base64')], { type: 'application/pdf' });
      saveAs(blob, invoiceNumber);
    }).catch((error) => {
      ErrorManagement.exception({
        exception: error,
        tags: {
          fileLocation: 'InvoiceDownloadButton',
          featureFunction: 'downloadInvoice',
        },
        fingerprint: ['invoice-download-button'],
      });
    });

    setIsDownloading(false);
  };

  return (
    <LinkAsButton
      variant="secondary"
      iconBefore="download"
      isLoading={isDownloading}
      onClick={() => {
        // GA3
        addEventEntry({
          eventCategory: origin,
          eventAction: 'download_invoice',
        });
        // GA4
        addDataLayerEntry('download_invoice', {
          action: 'download_invoice',
        });

        setIsDownloading(true);
        downloadInvoice();
      }}
      className="pd-text-sm"
    >
      <FormattedMessage id="account.invoices.download" defaultMessage="Download" />
    </LinkAsButton>
  );
};

export default InvoiceDownloadButton;
